export const userQueryKey = {
	GET_USER: ["user"],
};
